import { either, taskEither } from 'fp-ts';
import { errorToReactLeft, pipe } from 'utils/fp';
import { postNodepoolsTE } from 'api/nodepools/postNodepools';
import { CreateNodepoolBody } from 'api/nodepools/types';
import { getNodepoolTE } from 'api/nodepools/getNodepool';
import { listNodepoolsTE, listAllNodepoolsTE } from 'api/nodepools/listNodepools';
import { patchNodepoolsTE } from 'api/nodepools/patchNodepools';
import { listInstanceTypesTE } from 'api/nodepools/listInstanceTypes';
import { deleteNodepoolsTE } from 'api/nodepools/deleteNodepools';
import { displayError } from 'api/apiUtils';

export const nodepoolsApiEffects = {
  listInstanceTypesTE: (cloudProviderId: string, region: string) => {
    return pipe(
      listInstanceTypesTE({ cloudProviderId, region }, errorToReactLeft),
      taskEither.map((resp) => resp.instance_types),
    );
  },
  getNodepoolTE: (userId: string, computeClusterId: string, nodepoolId: string) =>
    pipe(
      getNodepoolTE({ userId, computeClusterId, nodepoolId }, errorToReactLeft),
      taskEither.map((resp) => resp),
    ),
  listNodepoolsTE: (userId: string, clusterId: string) =>
    pipe(
      listNodepoolsTE({ userId, clusterId }, errorToReactLeft),
      taskEither.map((x) => x.nodepools),
    ),
  listAllNodepoolsTE: (userId: string) =>
    pipe(
      listAllNodepoolsTE({ userId }, errorToReactLeft),
      taskEither.map((x) => x.nodepools),
    ),
  postNodepoolsTE: (userId: string, computeClusterId: string, body: CreateNodepoolBody) =>
    pipe(
      postNodepoolsTE({ userId, computeClusterId, body }),
      taskEither.map((resp) => resp),
    ),
  patchNodepoolsTE: (userId: string, computeClusterId: string, body: CreateNodepoolBody) =>
    pipe(
      patchNodepoolsTE({ userId, computeClusterId, body }),
      taskEither.map((resp) => resp),
    ),
  deleteNodepoolsTE: (userId: string, computeClusterId: string, nodepoolIds: string[]) =>
    pipe(
      deleteNodepoolsTE({ userId, computeClusterId, nodepoolIds }),
      taskEither.map((resp) => resp),
    ),
  createNodepool: async (userId: string, computeClusterId: string, createNodepoolBody: CreateNodepoolBody) => {
    const nodepoolResponse = await nodepoolsApiEffects.postNodepoolsTE(userId, computeClusterId, createNodepoolBody)();

    return pipe(
      nodepoolResponse,
      either.fold(
        (error) => {
          displayError(error.status.details, error.status.description);
          return false;
        },
        () => {
          return true;
        },
      ),
    );
  },
  editNodepool: async (userId: string, computeClusterId: string, createNodepoolBody: CreateNodepoolBody) => {
    const nodepoolResponse = await nodepoolsApiEffects.patchNodepoolsTE(userId, computeClusterId, createNodepoolBody)();

    return pipe(
      nodepoolResponse,
      either.fold(
        (error) => {
          displayError(error.status.details, error.status.description);
          return false;
        },
        () => {
          return true;
        },
      ),
    );
  },
};
